import React, { memo } from 'react';
import styled from 'styled-components';
import Checkbox from '@ui-elements/Checkbox';
import RequiredLabel from '@ui-elements/RequiredLabel';
import InputValidationErrorBox from '@ui-parts/InputValidationErrorBox';

import { CheckboxProps } from '@mui/material/Checkbox';
import { FONT_SIZES } from '~/assets/styles/base';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledCheckbox = styled(Checkbox)`
  & .MuiTypography-root span {
    font-size: ${FONT_SIZES.body3};
  }
`;

type Props = {
  label: string;
  checked: boolean;
  disabled?: boolean;
  handleChange: CheckboxProps['onClick'];
  required?: boolean;
  error?: boolean;
  dataTestId?: string;
  errorMessage?: string;
};

const TermsCheckbox: React.FC<Props & CheckboxProps> = ({
  label,
  checked,
  disabled,
  handleChange,
  required = true,
  error = false,
  errorMessage = '',
  dataTestId = '',
}): JSX.Element => (
  <>
    <Wrapper data-testid={`uiParts-TermsCheckbox-${dataTestId}`}>
      {required && <RequiredLabel />}
      <StyledCheckbox
        name="termsCheckbox"
        label={label}
        value=""
        checked={checked}
        disabled={disabled}
        handleChange={handleChange}
        dataTestId={dataTestId}
      />
    </Wrapper>
    {error ? (
      <InputValidationErrorBox message={errorMessage} dataTestId={dataTestId} position="center" />
    ) : null}
  </>
);

export default memo(TermsCheckbox);
